import { Button, CircularProgress, Dialog, DialogActions, DialogTitle } from '@mui/material'
import React from 'react'

interface DeleteButtonProps {
    onClick: () => void
    disabled?: boolean
    /**
     * Custom dialog title
     * DEFAULT: Opravdu chcete {deletedEntityName} smazat?
     */
    customDialogTitle?: string
    /**
     * Custom button text
     * DEFAULT: SMAZAT
     */
    customButtonText?: string
    deletedEntityName?: string
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
    onClick,
    disabled,
    customDialogTitle,
    deletedEntityName,
    customButtonText,
}: DeleteButtonProps) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    return (
        <>
            <Button variant='outlined' color='error' disabled={disabled} onClick={handleOpenDialog}>
                {disabled && <CircularProgress size={20} />}
                {customButtonText || 'SMAZAT'}
            </Button>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>
                    {customDialogTitle ? customDialogTitle : 'Opravdu chcete ' + deletedEntityName + ' smazat?'}
                </DialogTitle>
                <DialogActions>
                    <Button variant='outlined' onClick={handleCloseDialog}>
                        Ne
                    </Button>
                    <Button onClick={onClick} variant='contained' color='error' autoFocus>
                        Ano
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DeleteButton
